




















import Vue from "vue";

export default Vue.extend({
  name: "Notification",
  props: {
    showNotification: {
      type: Boolean,
      default: false,
    },
    type: String,
    isPermanent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false as boolean,
    };
  },
  created() {
    this.controlNotification();
  },
  methods: {
    controlNotification() {
      if (!this.isPermanent) {
        this.startTimer();
      }
      this.show = this.showNotification;
    },

    startTimer() {
      setTimeout(() => this.closeNotification(), 8000);
    },

    closeNotification() {
      this.show = false;
    },
  },

  watch: {
    showNotification() {
      this.controlNotification();
    },

    show() {
      this.$emit("showNotification", this.show);
    },
  },
});
